import { IS_DERIVED_CONSTRUCTOR } from './derived';
import { Overmind } from './Overmind';
import * as utils from './utils';
export * from './types';
export * from './operators';
export { Overmind } from './Overmind';
export { createOperator, createMutationOperator } from './operator';
export { MODE_DEFAULT, MODE_TEST, MODE_SSR, ENVIRONMENT, json } from './utils';
export { SERIALIZE, rehydrate } from './rehydrate';
export { statemachine } from './statemachine';
export * from './OvermindMock';
export * from './OvermindSSR';
export const derived = (cb) => {
    cb[IS_DERIVED_CONSTRUCTOR] = true;
    return cb;
};
export function createOvermind(config, options) {
    return new Overmind(config, options, { mode: utils.MODE_DEFAULT });
}
//# sourceMappingURL=index.js.map